import { useAtomValue } from 'jotai';

import protectionModalCartItemIdAtom from './protectionModalCartItemIdAtom';

const useProtectionModalCartItemId = () => {
  const protectionModalCartItemId = useAtomValue(protectionModalCartItemIdAtom);
  return protectionModalCartItemId;
};

export default useProtectionModalCartItemId;
